import StaticContentsContainer from '../components/StaticContentsContainer';
import guideRobot from '../../../../assets/images/test/guide-robot.png';

function GuideRobotDescription() {
    const container = StaticContentsContainer();
    container.classList.add('robot-description');
    container.innerHTML = `
    <h2>안내 로봇</h2>
    <div class="robot-img-container">
        <div class="robot-img">
            <img src="${guideRobot}" alt="guide robot">
        </div>
    </div>
    <ul class="robot-description-list">
        <li class="robot-description-item">환자의 목적지까지 동행 안내합니다.</li>
        <li class="robot-description-item">층간 이동이 포함된 동선에 사용하고자 할 때에는 로봇이 엘리베이터를 타도 혼잡하지 않을 지 고려해야 합니다.</li>        
    </ul>
    `;
    return container;
}

export default GuideRobotDescription;
